import React from "react";
import { Button } from "braid-design-system";

type TransactionActionsBarProps = {
    saving: boolean;
    isReadOnlyProcessedDocument: boolean;
    selectedSetupHasTempSave: boolean;
    onNew: () => void;
    onTemporarySave: () => void;
    onProcess: () => void;
    onPrint: () => void;
};

const TransactionActionsBar: React.FC<TransactionActionsBarProps> = ({
    saving,
    isReadOnlyProcessedDocument,
    selectedSetupHasTempSave,
    onNew,
    onTemporarySave,
    onProcess,
    onPrint,
}) => {
    return (
        <div className="transaction-actions transaction-card">
            <Button size="small" variant="ghost" onClick={saving ? undefined : onNew}>
                New
            </Button>
            {selectedSetupHasTempSave ? (
                <Button
                    size="small"
                    variant="ghost"
                    onClick={saving || isReadOnlyProcessedDocument ? undefined : onTemporarySave}
                >
                    Temporary Save
                </Button>
            ) : null}
            <Button
                size="small"
                variant="solid"
                tone="brandAccent"
                loading={saving}
                onClick={saving || isReadOnlyProcessedDocument ? undefined : onProcess}
            >
                Process
            </Button>
            <Button size="small" variant="ghost" onClick={onPrint}>
                Print
            </Button>
        </div>
    );
};

export default TransactionActionsBar;
